import { createRequestActions } from '../utils';
import * as rawMatSupplierTypes from './rawMatSupplierTypes';

export const listRawMatSuppliers = createRequestActions(rawMatSupplierTypes.RAWMAT_SUPPLIER_LIST);
